<template>
  <div class="page-toolbar bg-white shadow-sm p-3">
    <h4 class="m-0">
      Loan Calculator
    </h4>
    <b-button-toolbar key-nav>
      <b-button-group class="mx-1">
        <b-button
          variant="secondary"
          size="sm"
          @click="createCalculator"
        >
          <font-awesome-icon :icon="['fas', 'plus']" />
          Create New Calculator
        </b-button>
      </b-button-group>
    </b-button-toolbar>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';

const {mapActions: loanCalculatorActions} = createNamespacedHelpers('loanCalculator');
export default {
  name: 'LoanCalculatorHeader',
  methods:{
    ...loanCalculatorActions(['showAddEditModal']),
    createCalculator() {
      this.showAddEditModal();
    },
  },
};
</script>

<style scoped lang="scss">

</style>